import { DictionaryListResponse, DictionaryRequest } from "../entities/dictionary/DictionaryListResponse";
import ExportService from "./ExportService";
import RequestService from "./RequestService";

class DictionaryService {
    public static getList(): Promise<Error | DictionaryListResponse> {
        return RequestService.post("/importdictionary/list", {});
    }

    public static set(request: DictionaryRequest): Promise<Error | any> {
        return RequestService.post("/importdictionary/set", {
            ...request
        });
    }

    public static delete(id: number): Promise<Error | any> {
        return RequestService.post("/importdictionary/delete", { id });
    }

    public static export(id: number): Promise<Error | any> {
        return ExportService.requestExport("/importdictionary/exportrequest",
            { id },
            1, "dictionary_report.xlsx"
        );
    }
}

export default DictionaryService;